import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import Notification from "../giftList/Notification";
const PersonForm = ({
  id,
  fullName,
  email,
  handleSubmit,
  setPerson,
  formData,
  handleDelete,
  submitted,
}) => {
  const storedFormData = JSON.parse(sessionStorage.getItem("secret"));
  // eslint-disable-next-line no-unused-vars
  const [showData, setShowData] = useState(false);
  const [inputFullName, setInputFullName] = useState(fullName);
  const [inputEmail, setInputEmail] = useState(email);
  const [notification, setNotificationState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const setNotification = (notification) => {
    setNotificationState({ ...notification, show: true });
    setTimeout(() => {
      setNotificationState({ ...notification, show: false });
    }, 3000);
  };
  const handleSubmitForm = (event) => {
    event.preventDefault();
    if (inputFullName && inputEmail) {
      if(/^[\w.-]+@[\w.-]+\.\w{2,3}$/.test(inputEmail)) {
        setShowData(true);
        handleSubmit(id, inputFullName, inputEmail, submitted);
        setPerson((prevPerson) =>
            prevPerson.map((p) =>
                p.id === id ? { ...p, fullName: inputFullName, email: inputEmail } : p
            )
        );
      } else {
        setNotification({
          show: true,
          message: `Invalid email format!`,
          type: "danger",
        });
      }
    } else {
      setNotification({
        show: true,
        message: `Please enter the full name and email!`,
        type: "danger",
      });
    }
  };
  return (
    <form className="a"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleSubmitForm(e);
          if(!notification.show){
            setInputFullName(inputFullName);
          }
          else {
            setInputFullName("");
            setInputEmail("");
          }
        }
      }}
    >
      {notification.show && (
        <Notification message={notification.message} type={notification.type} />
      )}
      {submitted ? (
        <>
          <h5>{formData[id]?.fullName}</h5>
          <h5>{formData[id]?.email}</h5>
          {submitted && !storedFormData && (
            <FaTrash
              onClick={() => {
                handleDelete(id);
                setInputFullName('')
                setInputEmail('')
              }}
            />
          )}
          <br /> <br />
        </>
      ) : (
        <>
          <label htmlFor={`fullName-${id}`}>Full Name:</label>
          <input
            id={`fullName-${id}`}
            value={inputFullName}
            onChange={(event) => setInputFullName(event.target.value)}
          />
          <label htmlFor={`email-${id}`}>Email:</label>
          <input
            id={`email-${id}`}
            value={inputEmail}
            onChange={(event) => setInputEmail(event.target.value)}
          />
          <br />
          <br />
        </>
      )}
    </form>
  );
};

export default PersonForm;
